export function startOfDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function isOverdue(date) {
  if (!date) return false;
  return startOfDay(date) < startOfDay(new Date());
}

export function isDueToday(date) {
  if (!date) return false;
  return startOfDay(date).getTime() === startOfDay(new Date()).getTime();
}

export function formatDateForInput(value) {
  if (!value) return "";
  return new Date(value).toISOString().slice(0, 10);
}